// Import Dependencies
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';

import LoadingSpinner from '~/common/components/LoadingSpinner';
import AnnualPricingSwitch from '~/common/components/AnnualPricingSwitch';

import PlanCard from '~/views/Pricing/components/PlanCard';

import {
    SALES_PHONE_NUMBER_FORMATTED,
    SALES_PHONE_NUMBER_UNFORMATTED,
    BASE_ANNUAL_DISCOUNT_PERCENTAGE
} from '~/common/utils/consts';
import { pricingViewItemEvent, gtm } from '~/common/utils/tracking.js';

// Import Stylesheet
import styles from './pricing-card-list.css';

@inject('offerSuiteStore', 'promoCodeStore')
@observer
export default class extends Component {
    state = {
        offersFetched: false,
        selectedTerm: '',
        discountsFetched: false
    };

    autoDiscountsFetch = reaction(
        () => this.props.promoCodeStore.promoMaxAmount,
        () => {
            this.setState({ discountsFetched: true });
        }
    )

    componentDidUpdate(prevProps, prevState) {
        const {
            offerSuiteStore: { fetchedOffers, selectedPlanTerm }
        } = this.props;

        if (!prevState.offersFetched && fetchedOffers) {
            this.setState({ offersFetched: true });
        }

        if (prevState.selectedTerm !== selectedPlanTerm) {
            this.setState({ selectedTerm: selectedPlanTerm });
        }

        if ((!prevState.offersFetched || !prevState.discountsFetched || this.state.selectedTerm !== selectedPlanTerm) && this.state.offersFetched && this.state.discountsFetched) {
            gtm(pricingViewItemEvent(selectedPlanTerm));
        }
    }

    getOfferSuite(ev) {
        ev.preventDefault();
        this.props.offerSuiteStore.getOfferSuite();
    }

    AnnualSwitchDetail() {
        return this.props.offerSuiteStore.isTermMonthly ?
            <span><strong>PSSST!</strong> Save <strong>over {BASE_ANNUAL_DISCOUNT_PERCENTAGE}</strong> with annual billing!</span>
            :
            <span>Annual Savings over {BASE_ANNUAL_DISCOUNT_PERCENTAGE}</span>
        ;
    }

    renderCard = (i, planSet) => {
        return (
            <PlanCard
                eq={i}
                key={i}
                planSet={planSet}
            />
        );
    };

    render() {
        const {
            offerSuiteStore: { fetchedOffers, fetchedOffersError, pairedPlansByTerm, selectedPlanTerm, hasAnnualPlans }
        } = this.props;

        // render the plan list since we now have the plans
        return fetchedOffersError ?
            <div className={styles.error}>
                <p>
                    We weren't able to load plans. Please <a className={styles['error-link']} onClick={ev => this.getOfferSuite(ev)}>try again</a>.
                </p>
                <p>
                    If you keep experiencing this error, please contact our 24/7 Support at <a className={styles['error-link']} href={`tel:${SALES_PHONE_NUMBER_UNFORMATTED}`}>{SALES_PHONE_NUMBER_FORMATTED}</a>.
                </p>
            </div>
            :
            <div className={styles.wrapper}>
                {hasAnnualPlans &&
                    <div className={`${styles.toggle}`}>
                        <AnnualPricingSwitch modifiers={`${styles['toggle-pricing-page']}`} >
                            {this.AnnualSwitchDetail()}
                        </AnnualPricingSwitch>
                    </div>
                }
                {fetchedOffers ?
                    <div className={`${styles['plans-wrapper']}`}>
                        {pairedPlansByTerm.map((planSet, i) => {
                            return planSet[selectedPlanTerm] === false ?
                                <span key={i}></span>
                                :
                                this.renderCard(i, planSet);
                        })}
                    </div>
                    :
                    <LoadingSpinner className={styles.spinner} />
                }
            </div>;
    }
}
